import CircleIcon from '@mui/icons-material/Circle';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, ButtonBase, IconButton, Typography } from '@mui/material';

interface FilterChipProps {
  label: string;
  value: string;
  count?: number;
  /** Renders a filled (true) or outlined (false) dot before the label. Omit to hide the dot. */
  strict?: boolean;
  hideArrow?: boolean;
  expanded?: boolean;
  controls?: string;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  onRemove?: () => void;
}

const FilterChip = ({
  label,
  value,
  count,
  strict,
  hideArrow,
  expanded,
  controls,
  onClick,
  onRemove,
}: FilterChipProps) => {
  const StrictIcon = strict ? CircleIcon : CircleOutlinedIcon;
  const content = (
    <>
      {strict !== undefined && <StrictIcon sx={{ fontSize: 10 }} />}
      <Typography component="span" variant="body1" lineHeight={1.2}>
        {label}:{' '}
        <Box component="span" fontWeight={600}>
          {value}
        </Box>
      </Typography>
      {count !== undefined && (
        <Box
          component="span"
          sx={{
            px: 0.5,
            py: 0.25,
            borderRadius: 0.75,
            color: 'common.white',
            backgroundColor: 'primary.main',
            fontSize: 12,
          }}
        >
          +{count}
        </Box>
      )}
    </>
  );

  return (
    <Box
      sx={{
        whiteSpace: 'nowrap',
        height: 36,
        display: 'inline-flex',
        alignItems: 'center',
        color: 'primary.main',
        border: 1,
        borderColor: 'primary.main',
        borderRadius: 1,
        backgroundColor: 'common.white',
      }}
    >
      <ButtonBase
        aria-haspopup={expanded === undefined ? undefined : 'dialog'}
        aria-expanded={expanded}
        aria-controls={controls}
        onClick={onClick}
        sx={{
          flex: 1,
          minWidth: 0,
          alignSelf: 'stretch',
          display: 'inline-flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          gap: 1,
          px: 2,
          color: 'inherit',
          borderRadius: 1,
          '&:hover, &.Mui-focusVisible': {
            backgroundColor: 'action.hover',
          },
        }}
      >
        {content}
        {!hideArrow && <KeyboardArrowDownIcon fontSize="small" />}
      </ButtonBase>
      {onRemove && (
        <IconButton size="small" aria-label={`Remove ${label}`} onClick={onRemove} sx={{ mr: 0.5, color: 'inherit' }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
};

export default FilterChip;
